import { render, staticRenderFns } from "./ModalBindUserToAdmin.vue?vue&type=template&id=2cb49d1c&scoped=true"
import script from "./ModalBindUserToAdmin.vue?vue&type=script&lang=js"
export * from "./ModalBindUserToAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalBindUserToAdmin.vue?vue&type=style&index=0&id=2cb49d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb49d1c",
  null
  
)

export default component.exports